import {
	Button,
	CircularProgress,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { Check, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { AlertBoxActionEnum } from "web_myplann/Infrastructure/Api/Api";
import type { AlertTone } from "web_myplann/NotificationCenter/EventAlert/alertTone";
import { GRASS_GREEN_MYPLANN } from "web_myplann/Utils/constants";

type Props = {
	action: AlertBoxActionEnum;
	pendingAction: AlertBoxActionEnum | null;
	label: string;
	onClick: () => void;
	variant: "contained" | "text";
	ctaButtonColor?: AlertTone["ctaButtonColor"];
	Icon?: LucideIcon;
	subtext?: string;
};

export const EventActionButton: FC<Props> = ({
	action,
	pendingAction,
	label,
	onClick,
	variant,
	ctaButtonColor,
	Icon,
	subtext,
}) => {
	const { spacingTokens } = useTheme();
	const loading = pendingAction === action;
	const disabled = pendingAction !== null && !loading;

	return (
		<Stack alignItems="center" gap={spacingTokens.xs} width="100%">
			<Button
				variant={variant === "contained" ? "alertCta" : "alertCtaText"}
				color={variant === "contained" ? ctaButtonColor : undefined}
				fullWidth
				disableElevation
				onClick={onClick}
				loading={loading}
				disabled={disabled}
				loadingIndicator={
					<CircularProgress size={16} sx={{ color: "text.secondary" }} />
				}
				startIcon={
					variant === "contained" && Icon ? <Icon size={16} /> : undefined
				}
			>
				{label}
			</Button>
			{subtext && (
				<Stack direction="row" alignItems="center" gap={spacingTokens.xs}>
					<Check size={14} color={GRASS_GREEN_MYPLANN} aria-hidden />
					<Typography variant="deprecatedHint" color={GRASS_GREEN_MYPLANN}>
						{subtext}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};
